var _defs, _sodipodiNamedview, _metadata;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    width: 770.47559,
    height: 134,
    viewBox: "0 0 203.85499 35.454168",
    id: "svg8",
    sodipodiDocname: "logo.svg",
    inkscapeVersion: "1.0 (4035a4fb49, 2020-05-01)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    "fit-margin-bottom": 0,
    "fit-margin-right": 0,
    "fit-margin-left": 0,
    "fit-margin-top": 0,
    units: "px",
    id: "base",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageopacity: 0,
    inkscapePageshadow: 2,
    inkscapeZoom: 1.4,
    inkscapeCx: 425.75862,
    inkscapeCy: 77.524157,
    "inkscapeDocument-units": "mm",
    "inkscapeCurrent-layer": "layer1",
    "inkscapeDocument-rotation": 0,
    showgrid: "false",
    showguides: "true",
    "inkscapeGuide-bbox": "true",
    "inkscapeWindow-width": 1920,
    "inkscapeWindow-height": 1017,
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1
  }, /*#__PURE__*/React.createElement("inkscapeGrid", {
    originy: -39.158341,
    originx: -4.6670081,
    type: "xygrid",
    id: "grid833"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "151.43716,3.1749989",
    orientation: "0,-1",
    id: "guide835"
  }), /*#__PURE__*/React.createElement("sodipodiGuide", {
    position: "45.603823,34.925008",
    orientation: "0,-1",
    id: "guide863"
  }))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata5"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.6670083,-39.158332)",
    inkscapeLabel: "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    inkscapeGroupmode: "layer",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 5.2916667,71.437491 7.9374983,-2e-6 10.583334,-18.520822 -2.645833,18.520824 h 7.937499 C 42.333332,39.6875 44.979165,39.6875 37.041665,39.6875 l -10.583333,26.458333 2.645835,-23.8125 h -2.645834 l -15.875001,23.8125 7.9375,-26.458333 h -7.9375 z",
    id: "path839",
    sodipodiNodetypes: "ccccccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 55.827082,71.437489 H 34.660416 l 2.807937,-6.551849 5.129563,-11.968974 c 21.166667,10e-7 21.166667,10e-7 15.875,11.90625 h -15.875 l -1.852083,3.968751 13.756174,-10e-7 c 2.647993,10e-7 2.647993,10e-7 1.999389,1.297201 z",
    id: "path841",
    sodipodiNodetypes: "cccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 43.656249,62.177083 2.116668,-5.291666 c 12.700001,1e-6 12.7,0 10.054166,5.291666 z",
    id: "path843",
    sodipodiNodetypes: "cccc"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccccccccc",
    id: "path841-1",
    d: "m 66.145832,55.5625 21.16666,-3e-5 -2.80793,6.551853 -5.12955,11.968981 c -21.166653,3e-5 -21.166653,3e-5 -15.87501,-11.906227 l 15.875,-2.3e-5 1.85207,-3.968754 -13.756166,2.1e-5 c -2.64799,3e-6 -2.64799,3e-6 -1.999392,-1.297198 z",
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccc",
    id: "path843-3",
    d: "m 78.316672,64.822889 -2.11666,5.291669 c -12.699999,1.7e-5 -12.699999,1.8e-5 -10.054177,-5.291652 z",
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 91.281242,71.437505 3.89875,-9.357005 9.330418,9.357005 1.58751,-3.968755 -9.304818,-9.259704 13.273568,-7.13e-4 0.53097,-1.327429 C 111.125,55.5625 111.125,55.5625 108.54481,55.565121 L 97.890252,55.575884 104.51041,39.6875 h -5.29167 l -13.229158,31.75 z",
    id: "path865",
    sodipodiNodetypes: "ccccccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccccccccc",
    id: "path841-4",
    d: "m 128.32291,71.437491 h -21.16666 l 2.80794,-6.551849 5.12956,-11.968974 c 21.16667,10e-7 21.16667,10e-7 15.875,11.90625 h -15.875 l -1.85208,3.968751 13.75617,-10e-7 c 2.64799,10e-7 2.64799,10e-7 1.99939,1.297201 z",
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    sodipodiNodetypes: "cccc",
    id: "path843-8",
    d: "m 116.15208,62.177085 2.11667,-5.291666 c 12.7,1e-6 12.7,0 10.05417,5.291666 z",
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 133.61458,71.437501 139.7,56.885429 h -4.23334 c 0.70556,-1.76389 0.88195,-2.204862 1.5875,-3.96875 l 4.49792,-1e-6 h 5.29166 l 5.02709,1e-6 c -0.52916,1.32292 -1.05832,2.645836 -1.5875,3.96875 h -5.29167 c 0,0 -4.19563,10.142592 -6.08542,14.552089 z",
    id: "path885",
    sodipodiNodetypes: "ccccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 164.04166,55.562512 -6.61458,15.874989 -1.32291,2.645832 h -6.61459 c 0,0 1.32292,0 3.44235,-4.50437 l -7.4111,-7.401868 1.32292,-2.645833 7.28571,7.253468 4.62054,-11.222218 z",
    id: "path887",
    sodipodiNodetypes: "cccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 165.36458,74.083333 h -5.29167 c 0,0 1.04115,-1.694625 1.48503,-2.583097 1.93994,-3.88299 6.45247,-15.937736 6.45247,-15.937736 15.875,-1e-5 15.875,0 9.26042,15.875001 l -10.58333,1.1e-5 z",
    id: "path841-4-0",
    sodipodiNodetypes: "ccscccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 167.74583,68.791679 3.43959,-9.260416 c 7.40833,-1.1e-5 7.40832,-1.3e-5 3.43958,9.260405 z",
    id: "path843-8-5",
    sodipodiNodetypes: "cccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff9100",
      fillOpacity: 1,
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 202.40624,71.437501 h -21.16666 l 2.80794,-6.551849 5.12956,-11.968974 c 21.16667,1e-6 21.16667,1e-6 15.875,11.90625 h -15.875 l -1.85208,3.968751 13.75617,-10e-7 c 2.64799,10e-7 2.64799,10e-7 1.99939,1.297201 z",
    id: "path841-4-6",
    sodipodiNodetypes: "cccccccccc"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ff9100",
      strokeWidth: 1.05833,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 190.23541,62.177095 2.11667,-5.291666 c 12.7,10e-7 12.7,0 10.05417,5.291666 z",
    id: "path843-8-4",
    sodipodiNodetypes: "cccc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c046e4cc98f994bc26a8de7e24ce3d2c.svg";
export { ForwardRef as ReactComponent };